module.exports = __webpack_public_path__ + "static/media/addMember.3bf31984.svg";